module.exports = __webpack_public_path__ + "static/youknow_projectPrieview-523dccb851c9441f9bee195d59d1185f.webp";